export let reasonOftenUnread = "hpA7Fb";
export let reasonTooMuchMail = "S8FKne";
export default {reasonOftenUnread,reasonTooMuchMail};